import { render, staticRenderFns } from "./GuaranteeLegalMentions.vue?vue&type=template&id=4e22ef4a&"
import script from "./GuaranteeLegalMentions.vue?vue&type=script&lang=js&"
export * from "./GuaranteeLegalMentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e22ef4a')) {
      api.createRecord('4e22ef4a', component.options)
    } else {
      api.reload('4e22ef4a', component.options)
    }
    module.hot.accept("./GuaranteeLegalMentions.vue?vue&type=template&id=4e22ef4a&", function () {
      api.rerender('4e22ef4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/GuaranteeLegalMentions.vue"
export default component.exports